import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from '@/i18n';
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    emptyInspectionReport: {
      vehicle_type: null,
      marks: [],
      mileage: null,
      equipments: [],
      fuel: 0,
      paintwork_defect: null,
      special_marks: null
    },
    inspectionReportDataIsFetched: false,
    paintworkDefects: [],
    equipments: [],
    vehicleTypes: [],
    damages: [
      {type: 'dent', color: '#ee3833'},
      {type: 'spall', color: '#0004ff'},
      {type: 'crack', color: '#faa600'},
      {type: 'scratch', color: '#9f21b5'},
    ],
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
  },
  actions: {
    inspectionReportsDataGet({commit, state, dispatch}) {
      updateField(state, {path: 'inspectionReportDataIsFetched', value: false});
      axios.get(this._vm.$apiURL + '/inspection_report_data')
        .then((response) => {
          updateField(state, {path: 'paintworkDefects', value: response.data.paintworkDefects});
          updateField(state, {path: 'equipments', value: response.data.equipments});
          updateField(state, {path: 'vehicleTypes', value: response.data.vehicleTypes});
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root: true});
        })
        .finally(() => {
          updateField(state, {path: 'inspectionReportDataIsFetched', value: true});
        })
    },
  }
}
